import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getSpiSubscriptions(data) {
    return request.get(`/${platform}/spi_subscriptions`, data)
}

export function subscribeAllSpi(data) {
    return request.post(`/${platform}/spi_subscriptions/subscribe-all`, data)
}

export function subscribeSpi(data) {
    return request.post(`/${platform}/spi_subscriptions/subscribe`, data)
}

export function unsubscribeSpi(data) {
    return request.post(`/${platform}/spi_subscriptions/unsubscribe`, data)
}

export function querySpiSubscriptions(data) {
    return request.post(`/${platform}/spi_subscriptions/query`, data)
}
